var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248.645,
    height: 276.613,
    viewBox: "0 0 248.645 276.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_335",
    "data-name": "Grupo 335",
    transform: "translate(-410.5 -436.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_332",
    "data-name": "Grupo 332",
    transform: "translate(410.5 477.548)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_325",
    "data-name": "Grupo 325",
    transform: "translate(0 143.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_323",
    "data-name": "Grupo 323",
    transform: "translate(0 9.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_538",
    "data-name": "Caminho 538",
    d: "M416.475,1204.814h-4.068a1.907,1.907,0,1,1,0-3.814h4.068a1.907,1.907,0,0,1,0,3.814Z",
    transform: "translate(-410.5 -1201)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_539",
    "data-name": "Caminho 539",
    d: "M476.984,1204.814h-4.577a1.907,1.907,0,0,1,0-3.814h4.577a1.907,1.907,0,0,1,0,3.814Z",
    transform: "translate(-455.244 -1201)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_324",
    "data-name": "Grupo 324",
    transform: "translate(9.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_540",
    "data-name": "Caminho 540",
    d: "M450.907,1232.382a1.907,1.907,0,0,1-1.907-1.907v-4.068a1.907,1.907,0,1,1,3.814,0v4.068A1.907,1.907,0,0,1,450.907,1232.382Z",
    transform: "translate(-449 -1208.735)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_541",
    "data-name": "Caminho 541",
    d: "M450.907,1170.891a1.907,1.907,0,0,1-1.907-1.907v-4.577a1.907,1.907,0,0,1,3.814,0v4.577A1.907,1.907,0,0,1,450.907,1170.891Z",
    transform: "translate(-449 -1162.5)",
    fill: "#037cf9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_328",
    "data-name": "Grupo 328",
    transform: "translate(63.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_326",
    "data-name": "Grupo 326",
    transform: "translate(0 9.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_542",
    "data-name": "Caminho 542",
    d: "M666.475,639.814h-4.068a1.907,1.907,0,1,1,0-3.814h4.068a1.907,1.907,0,1,1,0,3.814Z",
    transform: "translate(-660.5 -636)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_543",
    "data-name": "Caminho 543",
    d: "M726.984,639.814h-4.577a1.907,1.907,0,1,1,0-3.814h4.577a1.907,1.907,0,0,1,0,3.814Z",
    transform: "translate(-705.244 -636)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_327",
    "data-name": "Grupo 327",
    transform: "translate(9.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_544",
    "data-name": "Caminho 544",
    d: "M700.907,667.382A1.907,1.907,0,0,1,699,665.475v-4.068a1.907,1.907,0,0,1,3.814,0v4.068A1.907,1.907,0,0,1,700.907,667.382Z",
    transform: "translate(-699 -643.735)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_545",
    "data-name": "Caminho 545",
    d: "M700.907,605.891A1.907,1.907,0,0,1,699,603.984v-4.577a1.907,1.907,0,0,1,3.814,0v4.577A1.907,1.907,0,0,1,700.907,605.891Z",
    transform: "translate(-699 -597.5)",
    fill: "#037cf9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_331",
    "data-name": "Grupo 331",
    transform: "translate(220.45 15.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    "data-name": "Grupo 329",
    transform: "translate(0 9.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_546",
    "data-name": "Caminho 546",
    d: "M1283.475,698.814h-4.068a1.907,1.907,0,1,1,0-3.814h4.068a1.907,1.907,0,1,1,0,3.814Z",
    transform: "translate(-1277.5 -695)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_547",
    "data-name": "Caminho 547",
    d: "M1343.984,698.814h-4.577a1.907,1.907,0,1,1,0-3.814h4.577a1.907,1.907,0,1,1,0,3.814Z",
    transform: "translate(-1322.244 -695)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_330",
    "data-name": "Grupo 330",
    transform: "translate(9.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_548",
    "data-name": "Caminho 548",
    d: "M1317.907,726.382a1.907,1.907,0,0,1-1.907-1.907v-4.068a1.907,1.907,0,1,1,3.814,0v4.068A1.907,1.907,0,0,1,1317.907,726.382Z",
    transform: "translate(-1316 -702.735)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_549",
    "data-name": "Caminho 549",
    d: "M1317.907,664.891a1.907,1.907,0,0,1-1.907-1.907v-4.577a1.907,1.907,0,0,1,3.814,0v4.577A1.907,1.907,0,0,1,1317.907,664.891Z",
    transform: "translate(-1316 -656.5)",
    fill: "#037cf9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_550",
    "data-name": "Caminho 550",
    d: "M526.927,1352.731a6.181,6.181,0,1,1,6.181-6.181A6.188,6.188,0,0,1,526.927,1352.731Zm0-8.548a2.367,2.367,0,1,0,2.367,2.367A2.369,2.369,0,0,0,526.927,1344.183Z",
    transform: "translate(-492.714 -1151.481)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_551",
    "data-name": "Caminho 551",
    d: "M1326.872,882.375a6.181,6.181,0,1,1,6.181-6.181A6.188,6.188,0,0,1,1326.872,882.375Zm0-8.548a2.367,2.367,0,1,0,2.367,2.367A2.37,2.37,0,0,0,1326.872,873.827Z",
    transform: "translate(-1089.259 -800.722)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_333",
    "data-name": "Grupo 333",
    transform: "translate(418.041 487.365)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_552",
    "data-name": "Caminho 552",
    d: "M1149.024,647.394a1.9,1.9,0,0,1-1.121-.366,117.243,117.243,0,0,0-11.435-7.352,1.907,1.907,0,1,1,1.872-3.323,121.127,121.127,0,0,1,11.809,7.592,1.907,1.907,0,0,1-1.124,3.449Z",
    transform: "translate(-958.693 -636.107)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_553",
    "data-name": "Caminho 553",
    d: "M588.4,692.439a1.907,1.907,0,0,1-1.309-3.294c1.887-1.782,3.855-3.524,5.851-5.178a1.907,1.907,0,0,1,2.434,2.936c-1.932,1.6-3.839,3.29-5.667,5.015A1.9,1.9,0,0,1,588.4,692.439Z",
    transform: "translate(-549.285 -671.471)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_554",
    "data-name": "Caminho 554",
    d: "M443.011,890.418a1.907,1.907,0,0,1-1.889-1.667,122.159,122.159,0,0,1-.01-30.583,119.33,119.33,0,0,1,14.66-44.128,1.907,1.907,0,1,1,3.318,1.881A115.535,115.535,0,0,0,444.9,858.646a118.348,118.348,0,0,0,.009,29.625,1.907,1.907,0,0,1-1.652,2.132A1.952,1.952,0,0,1,443.011,890.418Z",
    transform: "translate(-440.156 -768.077)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_555",
    "data-name": "Caminho 555",
    d: "M637.079,1425.233a1.9,1.9,0,0,1-.952-.256,121.234,121.234,0,0,1-13.353-8.95,1.907,1.907,0,0,1,2.329-3.02,117.356,117.356,0,0,0,12.931,8.667,1.907,1.907,0,0,1-.956,3.559Z",
    transform: "translate(-575.787 -1215.17)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_556",
    "data-name": "Caminho 556",
    d: "M817.218,1501.2a120.878,120.878,0,0,1-31.684-4.207,1.907,1.907,0,1,1,1-3.681,117.7,117.7,0,0,0,55.654,1.4,1.907,1.907,0,0,1,.812,3.727A121.323,121.323,0,0,1,817.218,1501.2Z",
    transform: "translate(-696.665 -1275.301)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_557",
    "data-name": "Caminho 557",
    d: "M1137.405,1438.04a1.907,1.907,0,0,1-.938-3.569c2.851-1.606,5.669-3.355,8.377-5.2a1.907,1.907,0,0,1,2.146,3.153c-2.8,1.9-5.707,3.709-8.651,5.368A1.9,1.9,0,0,1,1137.405,1438.04Z",
    transform: "translate(-958.693 -1227.35)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_558",
    "data-name": "Caminho 558",
    d: "M1254.877,1208.474a1.907,1.907,0,0,1-1.414-3.186,116.842,116.842,0,0,0,26.849-50.693,1.907,1.907,0,0,1,3.707.9,120.667,120.667,0,0,1-27.727,52.353A1.9,1.9,0,0,1,1254.877,1208.474Z",
    transform: "translate(-1046.297 -1021.673)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_559",
    "data-name": "Caminho 559",
    d: "M1370.678,989.92a1.907,1.907,0,0,1-1.907-1.907c0-3.511-.158-7.056-.469-10.534-.255-2.846-.618-5.714-1.079-8.527a1.907,1.907,0,0,1,3.764-.618c.477,2.9.852,5.867,1.115,8.805.321,3.591.484,7.249.484,10.874A1.907,1.907,0,0,1,1370.678,989.92Z",
    transform: "translate(-1131.481 -882.668)",
    fill: "#037cf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_334",
    "data-name": "Grupo 334",
    transform: "translate(460.008 436.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_560",
    "data-name": "Caminho 560",
    d: "M764.062,1073.737a33.612,33.612,0,0,1-7.419-66.378h0a33.6,33.6,0,1,1,7.419,66.378Zm-6.57-62.66a29.791,29.791,0,1,0,35.677,22.408,29.824,29.824,0,0,0-35.677-22.408Zm6.628,51a21.965,21.965,0,0,1-16.484-7.455,1.907,1.907,0,0,1,2.862-2.521,18.151,18.151,0,0,0,30.972-6.64,1.907,1.907,0,1,1,3.644,1.127,21.974,21.974,0,0,1-20.993,15.49Zm-14.865-17.405a8.392,8.392,0,0,1-1.868-16.572h0a8.391,8.391,0,1,1,1.868,16.572Zm-1.018-12.854a4.577,4.577,0,1,0,5.481,3.443,4.582,4.582,0,0,0-5.481-3.443Zm27.779,6.74a8.4,8.4,0,1,1,1.885-.214A8.465,8.465,0,0,1,776.016,1038.56Zm.017-12.971a4.577,4.577,0,1,0,4.462,3.558A4.576,4.576,0,0,0,776.032,1025.588Z",
    transform: "translate(-698.656 -861.614)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_561",
    "data-name": "Caminho 561",
    d: "M822.733,542.9a1.907,1.907,0,0,1-1.9-2.027l5.6-89.037a10.7,10.7,0,1,0-21.363-1.342l-5.678,90.5a1.907,1.907,0,1,1-3.807-.239l5.678-90.5a14.517,14.517,0,1,1,28.976,1.82l-5.111,81.292L867.329,463.7a14.533,14.533,0,0,1,19.938-4.894l.023.014a14.517,14.517,0,0,1,4.872,19.925L854.1,541.563a1.907,1.907,0,1,1-3.262-1.976L888.9,476.773a10.7,10.7,0,0,0-3.608-14.7l-.023-.014a10.71,10.71,0,0,0-14.678,3.621l-46.227,76.3A1.907,1.907,0,0,1,822.733,542.9Z",
    transform: "translate(-747.172 -436.649)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_562",
    "data-name": "Caminho 562",
    d: "M960.229,867.855a14.515,14.515,0,0,1-12.392-22.037l15.053-24.846a14.517,14.517,0,1,1,24.833,15.045L972.67,860.863A14.525,14.525,0,0,1,960.229,867.855Zm15.095-50.061a10.707,10.707,0,0,0-9.172,5.155L951.1,847.794a10.7,10.7,0,0,0,18.309,11.092l15.053-24.846a10.7,10.7,0,0,0-9.136-16.247Z",
    transform: "translate(-859.146 -718.03)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_563",
    "data-name": "Caminho 563",
    d: "M1038.576,930.4a14.522,14.522,0,0,1-12.391-22.046l15.053-24.846a14.518,14.518,0,0,1,24.833,15.045L1051.019,923.4a14.422,14.422,0,0,1-8.956,6.576A14.624,14.624,0,0,1,1038.576,930.4Zm15.1-50.077a10.783,10.783,0,0,0-2.571.313,10.634,10.634,0,0,0-6.6,4.849l-15.053,24.846a10.716,10.716,0,0,0,3.608,14.7h0a10.7,10.7,0,0,0,14.7-3.608l15.053-24.846a10.71,10.71,0,0,0-9.135-16.254Z",
    transform: "translate(-917.574 -764.668)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_564",
    "data-name": "Caminho 564",
    d: "M612.067,968.712a1.908,1.908,0,0,1-1.82-2.478l9.367-29.885a16.825,16.825,0,0,0-.633-11.759L608.265,900.03a36.3,36.3,0,0,1,2.97-34.606l16.164-24.53a15.6,15.6,0,0,1,14.574-6.958l38.925,3.8a13.148,13.148,0,0,1-2.105,26.209l-28.881-1.822-8.77,16.567a1.907,1.907,0,1,1-3.371-1.784l9.346-17.656a1.9,1.9,0,0,1,1.805-1.011l30.11,1.9a9.335,9.335,0,0,0,1.495-18.607l-38.925-3.8a11.79,11.79,0,0,0-11.018,5.26l-16.164,24.53a32.5,32.5,0,0,0-2.659,30.982l10.715,24.561a20.637,20.637,0,0,1,.777,14.424l-9.368,29.885A1.908,1.908,0,0,1,612.067,968.712Z",
    transform: "translate(-605.21 -732.863)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_565",
    "data-name": "Caminho 565",
    d: "M905.98,1141.817a1.909,1.909,0,0,1-1.82-2.478l9.559-30.5a20.747,20.747,0,0,1,7.828-10.713l23.9-16.8a32.811,32.811,0,0,0,13.833-25.29l.773-18.092a1.907,1.907,0,1,1,3.81.163l-.773,18.092a36.424,36.424,0,0,1-15.451,28.247l-23.9,16.8a16.914,16.914,0,0,0-6.381,8.733l-9.559,30.5A1.908,1.908,0,0,1,905.98,1141.817Z",
    transform: "translate(-828.081 -883.7)",
    fill: "#037cf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_566",
    "data-name": "Caminho 566",
    d: "M753.755,993.944a1.9,1.9,0,0,1-.768-.162,37.726,37.726,0,0,0-11.249-2.986,1.907,1.907,0,1,1,.26-3.805,41.217,41.217,0,0,1,12.526,3.3,1.907,1.907,0,0,1-.77,3.653Z",
    transform: "translate(-705.698 -847.053)",
    fill: "#037cf9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVSign);
export default __webpack_public_path__ + "static/media/v-sign.684d65ca94215da382057a4a421e199b.svg";
export { ForwardRef as ReactComponent };